"use client";
import Image, { StaticImageData } from "next/image";
import React from "react";

type MembershipCardProps = {
  logo: StaticImageData | string;
  subtitle: string;
  title: string;
  // Optional width/height overrides for logos
  logoWidth?: number;
  logoHeight?: number;
};

export default function MembershipCard({
  logo,
  subtitle,
  title,
  logoWidth = 206,
  logoHeight = 55,
}: MembershipCardProps) {
  return (
    <div className="border border-[#ecf0f6] bg-white w-full h-full">
      <div className="flex flex-col items-center justify-start gap-6 px-10 py-10">
        <Image
          src={logo}
          alt={title}
          width={logoWidth}
          height={logoHeight}
          className="object-contain"
          sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
          priority
          fetchPriority="high"
        />
        <div className="flex flex-col items-center justify-start gap-2">
          <p className="text-[#636364] text-[15px] leading-[140%] font-[500] text-center max-w-[32ch]">
            {subtitle}
          </p>
          <h3 className="text-[#00040b] text-[18px] leading-[120%] clash-font font-semibold text-center max-w-[32ch]">
            {title}
          </h3>
        </div>
      </div>
    </div>
  );
}
